import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getData } from "services/api-actions";
import { ProfileListData, RoleListData } from "routes/analysis/types/analysis";
import { GeneralFilter } from "types/common";
import { getBasePayload } from "routes/analysis/queries/analysis";
import { TestData } from "routes/analysis/types/user";

export const FetchRoles = (analysisId?: string, filter?: GeneralFilter, offset?: number, attached?: boolean, composite?: boolean, search?: string) => useQuery({
  queryKey: ["roles", analysisId, filter, offset, attached, composite, search],
  queryFn: () => getRoles(analysisId, filter, offset, attached, composite, search),
  placeholderData: keepPreviousData,
  staleTime: 1000 * 60 * 5
});

export const FetchRoleTests = (analysisId?: string, roleId?: string, filter?: GeneralFilter, composite?: boolean) => useQuery({
  queryKey: ["roleTests", analysisId, roleId, composite, filter],
  queryFn: () => getRoleTests(analysisId, roleId, filter, composite),
  staleTime: 1000 * 60 * 5
});

export const FetchProfiles = (analysisId?: string, filter?: GeneralFilter, offset?: number, attached?: boolean, composite?: boolean, search?: string) => useQuery({
  queryKey: ["profiles", analysisId, filter, attached, composite, search, offset],
  queryFn: () => getProfiles(analysisId, filter, offset, attached, composite, search),
  placeholderData: keepPreviousData,
  staleTime: 1000 * 60 * 5
});

const getRoles = async (analysisId?: string, filter?: GeneralFilter, offset?: number, attached?: Boolean, composite?: Boolean, search?: string) => {
  if (!analysisId) throw new Error("No analysis id provided");
  if (!filter) throw new Error("No filter provided");
  const payload = getBasePayload(filter, { 
    offset: offset, 
    attached: attached ? 1 : 0, 
    composite: composite ? 1 : 0,
    s: search
   });
  const data = await getData<RoleListData>(`analysis/${analysisId}/roles?${payload}`);
  if (!data.result) throw new Error("No data found");
  return data.result;
}

const getProfiles = async (analysisId?: string, filter?: GeneralFilter, offset?: number, attached?: boolean, composite?: boolean, search?: string) => {
  if (!analysisId) throw new Error("No analysis id provided");
  if (!filter) throw new Error("No filter provided");
  const payload = getBasePayload(filter, { 
    offset: offset,
    attached: attached ? 1 : 0, 
    composite: composite ? 1 : 0, 
    s: search });
  const data = await getData<ProfileListData>(`analysis/${analysisId}/profiles?${payload}`);
  if (!data.result) throw new Error("No data found");
  return data.result;
}

const getRoleTests = async (analysisId?: string, roleId?: string, filter?: GeneralFilter, composite?: boolean) => {
  if (!analysisId) throw new Error("No analysis id provided");
  if (!roleId) throw new Error("No role id provided");
  if (!filter) throw new Error("No filter provided");
  const payload = getBasePayload(filter, { composite: composite ? 1 : 0 });
  const data = await getData<TestData[]>(`analysis/${analysisId}/roles/${roleId}/tests?${payload || ""}`);
  if (!data.result) throw new Error("No data found");
  return data.result;
}